import React, { FC, ReactNode, useEffect } from 'react'
import { FormProvider, useFormContext } from 'react-hook-form'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useCreateLoadForm } from 'apps/fleet-planner/hooks'
import { CreateLoadSchemaType } from 'apps/fleet-planner/schema'
import { useMembershipValidation } from '../hooks/useMembershipValidation'
import { CreateLoadDefaultValues } from '../utils/getDefaultLoadState'
import { useMembershipContext } from './MembershipContext'

interface CreateLoadFormProviderProps {
  children: ReactNode
  defaultValues?: CreateLoadDefaultValues
}

/**
 * Provides form methods and data for all children elements
 */
export const CreateLoadFormProvider: FC<CreateLoadFormProviderProps> = ({
  children,
  defaultValues,
}) => {
  const { getUserMotorCarriers } = useMembershipContext()
  const { isAdminForCarrier, isAssociatedCarrier, isRoleTypeForCarrier } = useMembershipValidation()
  const { getFlag } = useFeatureFlagContext()
  const { enabled: isFpCarrierPortalEnabled } = getFlag('fpCarrierPortal')

  /**
   * Fetch the list of user's carriers on mount
   */
  useEffect(() => {
    if (isFpCarrierPortalEnabled && getUserMotorCarriers) {
      getUserMotorCarriers()
    }
  }, [isFpCarrierPortalEnabled])

  const methods = useCreateLoadForm({
    defaultValues,
    context: {
      isFpCarrierPortalEnabled,
      isRoleTypeForCarrier,
      isAssociatedCarrier,
      isAdminForCarrier,
    },
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}

// Helper function for context
export const useCreateLoadFormContext = () => useFormContext<CreateLoadSchemaType>()
